/**
 * Created by andrey on 06.06.18.
 */

const DailyTaskView = cc.Node.extend({
    ctor: function (task) {
        this._super();

        this.isWide = cleverapps.config.type === "merge";

        this.task = task;

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.DailyTaskView;

        this.icon = this.createIcon();
        this.title = this.createTitle();
        this.rewards = this.createRewards();
        this.title.setAnchorPoint(0, 0.5);
        this.rewards.setAnchorPoint(0, 0.5);

        const titleAndRewards = new cleverapps.Layout([this.title, this.rewards], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.titleMargin
        });

        const titleAndRewardsNode = new cc.Node();
        titleAndRewardsNode.setAnchorPoint(0.5, 0.5);
        titleAndRewardsNode.setContentSize(this.isWide ? styles.titleAndRewards.wide.width : styles.titleAndRewards.width, styles.titleAndRewards.height);
        titleAndRewardsNode.addChild(titleAndRewards);
        titleAndRewards.setAlignment(styles.titleAndRewards);

        const progressBlock = this.createProgressBlock();

        const items = [this.icon, titleAndRewardsNode, progressBlock];

        this.content = new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });
        this.addChild(this.content);

        this.background = this.createBackground();

        this.setContentSize2(this.background.getContentSize());
        this.background.setAlignment(this.width / 2, this.height / 2);
        this.content.setAlignment(this.width / 2, this.height / 2);

        this.createSwapButton();
        this.setCascadeOpacityEnabledRecursively(true);

        this.onUpdate();
        this.task.on("update", this.onUpdate.bind(this), this);
    },

    createProgressBlock: function () {
        const styles = cleverapps.styles.DailyTaskView;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles.progressBlock);

        this.progressBar = this.createProgressBar();
        this.progressBar.setAnchorPoint(0.5, 0.5);
        node.addChild(this.progressBar);
        this.progressBar.setAlignment(node.width / 2, node.height / 2);

        this.check = new cc.Sprite(bundles.dailytasks.frames.daily_task_mark_png);
        node.addChild(this.check);
        this.check.setAlignment(node.width / 2, node.height / 2);

        this.rewardButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            text: Messages.get("DailyTaskView.Get"),
            onClicked: this.onRewardButtonClick.bind(this)
        });
        this.rewardButton.setCascadeOpacityEnabled(true);
        this.rewardButton.setLocalZOrder(1);
        this.rewardButton.content.setLocalZOrder(1);

        node.addChild(this.rewardButton);
        this.rewardButton.setAlignment(node.width / 2, node.height / 2);

        this.rewardButton.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.CallFunc(this.completeAnimation.bind(this)),
            new cc.DelayTime(5)
        )));

        cleverapps.UI.applyHover(this.rewardButton, {
            onMouseOver: this.stopCompleteAnimation.bind(this)
        });

        return node;
    },

    completeAnimation: function () {
        if (!this.rewardButton.isVisible() || PointerHandler.getState(this, "hovered") || PointerHandler.getState(this, "pressed")) {
            return;
        }

        this.completeAction = this.rewardButton.runAction(
            StandartAnimations.complete(this.rewardButton, { stripe: bundles.animations_library.jsons.complete_button_json })
        );
    },

    stopCompleteAnimation: function () {
        if (this.completeAction && !this.completeAction.isDone()) {
            this.rewardButton.stopAction(this.completeAction);
            delete this.completeAction;
        }
    },

    createBackground: function () {
        const background = cleverapps.UI.createScale9Sprite(bundles.dailytasks.frames.daily_task_bg_png);
        background.setContentSize2(this.content.getContentSize());
        this.addChild(background, -1);

        return background;
    },

    onRewardButtonClick: function () {
        if (!this.task.isFinished() || this.task.collected) {
            return;
        }

        this.rewardsList.receiveRewards();
        this.rewardsList.receiveRewardsAnimation({
            flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
            noFadeOut: true,
            callback: cleverapps.dailyTasks.collectLastTask
        });
        cleverapps.dailyTasks.collect(this.task);
    },

    createProgressBar: function () {
        const styles = cleverapps.styles.DailyTaskView;

        const bar = new ScaledProgressBar({
            progress: bundles.progress_bar.frames.bar_green,
            background: bundles.progress_bar.frames.bg_green,
            progressFrames: styles.progressBar.progressFrames,
            barText: {
                font: cleverapps.styles.FONTS.DAILY_TASK_PROGRESS_FONT,
                dy: styles.progressBar.text.dy
            },
            height: styles.progressBar.height
        });
        bar.setAnchorPoint(0, 0);
        bar.setLength(styles.progressBar.width);
        bar.setPercentage(0);

        if (cleverapps.config.debugMode) {
            const onBarClick = function () {
                cleverapps.eventBus.trigger("taskEvent", DailyTasks.GuessName(this.task.type), 1, this.task.data);
            }.bind(this);

            const onBarDoubleClick = function () {
                cleverapps.eventBus.trigger("taskEvent", DailyTasks.GuessName(this.task.type), this.task.goal, this.task.data);
            }.bind(this);

            cleverapps.UI.onClick(bar, onBarClick, { onDoubleClick: onBarDoubleClick });
        }

        return bar;
    },

    createRewards: function () {
        const reward = this.task.getReward();

        const styles = cleverapps.styles.DailyTaskView;

        const rewardsTitle = cleverapps.UI.generateOnlyText(Messages.get("RewardsListComponent.rewardTitle"), cleverapps.styles.FONTS.DAILY_TASK_REWARD_FONT || cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        const rewardsList = this.rewardsList = new RewardsListComponent(reward, {
            font: cleverapps.styles.FONTS.DAILY_TASK_REWARD_FONT || cleverapps.styles.FONTS.WINDOW_SMALL_TEXT,
            margin: styles.reward.margin,
            noPrefix: true,
            textDirection: cleverapps.UI.HORIZONTAL,
            textMargin: styles.reward.textMargin,
            small: true,
            iconWrap: styles.reward.iconWrap,
            noShowControls: true,
            event: cleverapps.EVENTS.EARN.DAILY_TASKS
        });

        const rewards = new cleverapps.Layout([rewardsTitle, rewardsList], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.reward.margin.x
        });
        cleverapps.UI.fitToBox(rewards, {
            width: this.isWide ? styles.titleAndRewards.wide.width : styles.titleAndRewards.width,
            height: styles.titleAndRewards.height
        });

        return rewards;
    },

    createTitle: function () {
        const styles = cleverapps.styles.DailyTaskView;

        const titleNode = new cc.Node();
        titleNode.setAnchorPoint(0.5, 0.5);
        titleNode.setContentSize2(this.isWide ? styles.title.wide.width : styles.title.width, styles.title.height);
        titleNode.setCascadeOpacityEnabled(true);

        const titleOptions = this.task.getTitle();
        const title = cleverapps.UI.generateOnlyText(Messages.get(titleOptions.text, titleOptions.replace), cleverapps.styles.FONTS.DAILY_TASK_FONT || cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);
        title.setDimensions(titleNode.width, 0);
        title.fitTo(undefined, titleNode.height);

        titleNode.addChild(title);
        title.setAlignment(title.width / 2, titleNode.height / 2);

        return titleNode;
    },

    createIcon: function () {
        const styles = cleverapps.styles.DailyTaskView.icon;

        const icon = new cc.Node();
        icon.setAnchorPoint(0.5, 0.5);

        const image = this.task.getIcon();

        const bg = cleverapps.UI.createScale9Sprite(bundles.dailytasks.frames.daily_task_icon_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        if (styles.bg) {
            bg.setContentSize2(this.isWide ? styles.bg.wide.width : styles.bg.width, styles.bg.height);
        }
        icon.addChild(bg);
        icon.setContentSize2(bg.getContentSize());
        bg.setAlignment(icon.width / 2, icon.height / 2);

        if (bundles.dailytasks.frames.daily_task_icon_frame_png) {
            const iconFrame = this.iconFrame = new cc.Scale9Sprite(bundles.dailytasks.frames.daily_task_icon_frame_png);
            iconFrame.setAlignment(icon.width / 2, icon.height / 2);
            iconFrame.setLocalZOrder(10);
            icon.addChild(iconFrame);
            iconFrame.setContentSize2(styles.frame);
        }

        image.setAlignment(icon.width / 2, icon.height / 2);
        icon.addChild(image);

        icon.setCascadeOpacityEnabled(true);

        return icon;
    },

    updateProgress: function () {
        this.progressBar.setGoal(this.task.goal);
        this.progressBar.setPercentage(this.task.progress);
    },

    onUpdate: function () {
        this.rewardButton.setVisible(!this.task.collected && !this.task.expired && this.task.isFinished());

        const styles = cleverapps.styles.DailyTaskView;

        if (this.iconFrame) {
            this.iconFrame.setSpriteFrame(this.task.isFinished() ? bundles.dailytasks.frames.daily_task_icon_frame_completed_png : bundles.dailytasks.frames.daily_task_icon_frame_png);
            this.iconFrame.setContentSize2(styles.icon.frame);
        }

        if (this.check) {
            this.check.visible = this.task.isFinished() && this.task.collected;
        }

        this.updateProgress();

        if (this.task.isFinished()) {
            this.progressBar.setVisible(false);
            if (this.swapBtn) {
                this.swapBtn.removeFromParent();
                delete this.swapBtn;
            }

            if (this.task.collected) {
                if (bundles.dailytasks.frames.daily_task_bg_completed_png) {
                    this.background.setSpriteFrame(bundles.dailytasks.frames.daily_task_bg_completed_png);
                }

                [this.icon, this.background, this.title, this.rewards].forEach((item) => {
                    item.setOpacity(140);
                });
            }
        }
    },

    createSwapButton: function () {
        if (!this.task.isSwappable() || this.task.isFinished()) {
            return;
        }

        const styles = cleverapps.styles.DailyTaskView;

        this.swapBtn = new DailytaskSwapButton(this.task, this.isWide);
        this.content.addChild(this.swapBtn);
        if (this.isWide) {
            this.swapBtn.setAlignment(styles.swapButton.wide);
        } else {
            this.swapBtn.setAlignment(styles.swapButton);
        }
    }
});

cleverapps.styles.DailyTaskView = {
    titleMargin: 0,
    margin: 10,
    padding: {
        left: 10,
        right: 40,
        y: 10
    },

    titleAndRewards: {
        width: 394,
        height: 138,
        x: { align: "left" },
        y: { align: "center" },

        wide: {
            width: 606
        }
    },

    content: {
        x: { align: "center" },
        y: { align: "center" }
    },

    reward: {
        margin: {
            x: 10
        },
        iconWrap: {
            width: 50,
            height: 50
        },
        textMargin: 0
    },

    progressBlock: {
        width: 230,
        height: 35
    },

    icon: {
        x: { align: "left", dx: 25 },
        y: { align: "center", dy: 0 },

        frame: {
            width: 142,
            height: 142
        }
    },

    title: {
        width: 300,

        wide: {
            width: 606
        },

        height: 80
    },

    button: {
        width: 168,
        height: 80
    },

    swapButton: {
        wide: {
            x: { align: "right", dx: -275 },
            y: { align: "center", dy: 0 }
        },

        x: { align: "right", dx: 0 },
        y: { align: "top", dy: 0 }
    },

    progressBar: {
        width: 230,

        text: {
            dy: 0
        }
    }
};
